import CreateListingsMonitor from './listings';
import CreateExchangeRateMonitor from './exchangerate';

const CreateMonitors = async (actions) => {
  await CreateListingsMonitor(actions);
  await CreateExchangeRateMonitor(actions);
};

export default CreateMonitors;
